<template>
  <div>
    <Card class="p-shadow-1">
      <template #title>
        Validar
      </template>
      <template #content>
        <Message severity="error" v-if="linhasErros.length > 0">
          Linhas com erros: {{ linhasErros.length }}
        </Message>
        <p v-if="funcionarios.length > 0"><strong>Selecione a Escala de Horários.</strong> </p>
        <div class="p-fluid p-formgrid p-grid" v-if="funcionarios.length > 0">
          <div class="p-field p-col-12 p-md-4">
              <label>Escala de Horários</label>
              <Dropdown v-model="escalaSelecionada" :options="escalas" optionLabel="nomeRef"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
							<label>Data de início da escala</label>
							<Calendar v-model="dataIinicioEscala" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" 
							:monthNavigator="true" :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR"/>								
						</div>
        </div>
        
        <DataTable :value="linhasErros" :filters="filtro1" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped" v-if="linhasErros.length > 0">	
					<Column field="erro" header="Erro" sortable></Column>				
				</DataTable>

        <DataTable :value="funcionarios" :filters="filtro2" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped" v-if="funcionarios.length > 0">	
					<Column field="nome" header="Nome" sortable></Column>	
          <Column field="pis" header="Pis" sortable></Column>	
          <Column field="cracha" header="Crachá" sortable></Column>	
          <Column field="registro" header="Registro" sortable></Column>	
          <Column field="dataAdmissao" header="Data de Admissão" sortable>
            <template #body="{data}">
                {{ formatarDataTabela(data.dataAdmissao) }}
            </template>
          </Column>				
          <Column field="cargo.nome" header="Cargo" sortable></Column>	
          <Column field="centroCusto.nome" header="Centro de Custo" sortable></Column>	
				</DataTable>

      </template>
      <template #footer>
          <div class="p-grid p-nogutter p-justify-between">
              <div>
                <Button label="Voltar" @click="anterior" icon="pi pi-angle-left" class="p-mr-2" />
                <Button label="Cancelar" @click="cancelar" icon="pi pi-times" class="p-button-secondary" />
              </div>
              <div>
                <Button label="Confirmar" @click="proximo" icon="pi pi-checked" />
              </div>
          </div>            
      </template>
    </Card>
  </div>
</template>

<script>

import { exibirMensagem, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      escalas: [],
      dataIinicioEscala: new Date(),
      escalaSelecionada: null,
      funcionarios: [],
      linhasErros: [],
      cnpj: null,
      localeCalendarBR: localeCalendarBR,
      filtro1: {},
      filtro2: {},
      rangeData: '',
    }
  },
  methods: {
    carregar() {
      let json = sessionStorage.getItem('empregadosArquivoCSV');
      sessionStorage.removeItem('empregadosArquivoCSV');
      if(json != null) {
        let dados = JSON.parse(json);  
        this.escalas = dados.escalas;    
        this.cnpj = dados.cnpj;    
        if(this.escalas.length > 0) {
          this.escalas.forEach(escala => {
            escala['nomeRef'] = escala.descricao + ' ('+escala.id+' - '+(escala.tipo == 1 ? 'Quadro de Horários' : 'Revezamento')+')';
          });
          this.escalaSelecionada = this.escalas[0];          
        }
        this.funcionarios = dados.funcionarios;
        dados.linhasErros.forEach(erro => {
          this.linhasErros.push({erro: erro});          
        });
      }
    },
    proximo() {
      let dados = {
        dataIinicioEscala: this.formatarData(this.dataIinicioEscala),
        escalaSelecionada: this.escalaSelecionada,
        funcionarios: this.funcionarios,
        cnpj: this.cnpj,
      }
      sessionStorage.setItem('empregadosArquivoCSV', JSON.stringify(dados));
      this.$emit('nextPage', {formData: {}, pageIndex: 1});
    },
    anterior() {
      this.$emit('prevPage', {formData: {}, pageIndex: 1});
    },
    cancelar() {
        this.$router.push('/cadastros/funcionarios');
    },
    formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
    formatarDataTabela(data) {
			let partes = data.split('-');
			const strData = partes[2] + '/' + partes[1] + '/' + partes[0];
			return strData;
		},
    criarRangeData() {
			let anoAtual = new Date().getFullYear();     
			this.rangeData = (anoAtual-10)+':'+anoAtual;     
		},
  },
  created() {
    this.carregar();
    this.criarRangeData();
  }
}
</script>

<style>

</style>